import CameraButton from './CameraButton';
import useCamera from './hooks/useCamera';
import CameraDisplay from './CameraDisplay';
import CameraError from 'components/Selfiebooth/CameraError'
import PhotoEditor from 'components/Selfiebooth/PhotoEditor';
import ShareDisplay from 'components/Selfiebooth/ShareDisplay';
import FullPageModal from 'components/FullPageModal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next'
import {
  StyledSelfieboothButton,
  StyledSelfieboothButtonOutlined,
  StyledSelfieboothSectionButton,
} from 'components/Selfiebooth/styled'

interface SelfieboothProps {
  app: any;
  cardInfos: any;
  part: any;
  visitorId: string;
  isModal?: boolean;
  onClose?: () => void;
  t: any;
}

const Selfiebooth = ({ app, cardInfos, part, visitorId, t }: SelfieboothProps) => {
  const [finalImg, setFinalImg] = useState<string|null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [method, setMethod] = useState<'camera'|'upload'>('camera');
  const selfiebooth = useSelector((store: any) => store.modules?.photobooth?.list[part.voxpopId || part.id]);

  const { startCamera, stream, stopCamera, capturePhoto, isCapturing, photoUrl, cancelPhoto, setPhotoUrl, errorCamera, switchCamera } = useCamera();

  const handleCancel = (source: string) => {
    setFinalImg(null);
    setMethod('camera');
    cancelPhoto();
    if (selfiebooth.part.inModal && source === 'inModal') setOpen(false);
  };

  const handleUploadPhoto = (fileUrl: string) => {
    setMethod('upload')
    setPhotoUrl(fileUrl);
  };

  const renderContent = (isModal) => {
    if (finalImg) {
      return <ShareDisplay selfiebooth={selfiebooth} onCancel={() => handleCancel('notModal')} finalImg={finalImg} visitorId={visitorId} app={app} cardInfos={cardInfos} isModal={isModal} />;
    }

    if (photoUrl) {
      return (
        <PhotoEditor
          selfiebooth={selfiebooth}
          photoUrl={photoUrl}
          isCapturing={isCapturing}
          onRetake={method === 'upload' ? () => handleCancel(selfiebooth.part.inModal ? 'inModal' : 'notModal') : startCamera}
          setFinalImg={setFinalImg}
          method={method}
          setPhotoUrl={setPhotoUrl}
          isModal={isModal}
        />
      );
    }

    return (
      <>
        {!stream ? (
          !errorCamera ?
            <CameraButton selfiebooth={selfiebooth} startCamera={startCamera} onUploadPhoto={handleUploadPhoto} isModal={isModal} />
            :
            <CameraError selfiebooth={selfiebooth} onUploadPhoto={handleUploadPhoto} />
        ) : (
          <CameraDisplay stream={stream} stopCamera={stopCamera} capturePhoto={capturePhoto} switchCamera={switchCamera} />
        )}
      </>
    );
  };

  if (!selfiebooth.part.inModal) {
    return renderContent(false);
  }

  return <>
    <StyledSelfieboothSectionButton>
      {selfiebooth.part.inModalButtonAlternate ? (
        <StyledSelfieboothButtonOutlined onClick={() => setOpen(true)}>
          <label>{selfiebooth.part.inModalButtonText || t('photobooth.takePhoto')}</label>
        </StyledSelfieboothButtonOutlined>
      ) : (
        <StyledSelfieboothButton onClick={() => setOpen(true)}>
          <label>{selfiebooth.part.inModalButtonText || t('photobooth.takePhoto')}</label>
        </StyledSelfieboothButton>
      )}

    </StyledSelfieboothSectionButton>
    <FullPageModal
      content={renderContent(true)}
      isVisible={open}
      toggle={() => {
        stopCamera();
        handleCancel('inModal');
      }}
      id="selfiebooth-modal"
    />
  </>;
};

export default withTranslation()(Selfiebooth);